var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"my-message-bubble bg-blue-400 hover:bg-blue-500 duration-200 cursor-pointer text-white border my-rounded shadow p-6 mb-3 w-5/6 md:w-3/4 ml-auto",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a45246ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/processes/cards/tchat/Components/MyMessageBubble.vue
// module id = null
// module chunks = 